import {ApiRequestStates} from '../const'
import {reducer} from './helpers'

import * as addToLookActions from '../actions/addToLook'

const initialState = {
  error: null,
  status: ApiRequestStates.IDLE,
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case addToLookActions.ADD_TO_LOOK_PENDING:
      return {
        error: null,
        status: ApiRequestStates.PENDING,
      }
    case addToLookActions.ADD_TO_LOOK_FAILURE:
      return {
        error: payload,
        status: ApiRequestStates.ERROR,
      }
    case addToLookActions.ADD_TO_LOOK_SUCCESS:
      return {status: ApiRequestStates.SUCCESS}
    case addToLookActions.ADD_TO_LOOK_IDLE:
      return {
        error: null,
        status: ApiRequestStates.IDLE,
      }
    default:
      return null
  }
})
